import React from 'react';
import { OrganizationTabParamList } from '../../../../../utils/appNavigationNames';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { RouteProp } from '@react-navigation/native';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';
import useOrganizationUsers from '../../../../../hooks/api/useOrganizationUsers';
import OrganizationUserDetails from '../../../../shared/OrganizationUsers/OrganizationUserDetails';

export type OrganizationInvitationScreenOwnProps = {};

export type OrganizationInvitationScreenProps = OrganizationInvitationScreenOwnProps & {
    route: RouteProp<OrganizationTabParamList, 'user'>;
};

const OrganizationInvitationScreen: React.FC<OrganizationInvitationScreenProps> = (props) => {
    const { isLoadingUser } = useOrganizationUsers({
        organizationUserId: props.route.params.organizationUserId,
    });
    return (
        <AnimateLoadedContent isLoading={isLoadingUser}>
            {() => (
                <ActionButtonLayout scrollable>
                    <MainContentContainer>
                        <OrganizationUserDetails organizationUserId={props.route.params.organizationUserId} />
                    </MainContentContainer>
                </ActionButtonLayout>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(OrganizationInvitationScreen);
